import { render, staticRenderFns } from "./MsgCompleto.vue?vue&type=template&id=fb7e26f6"
import script from "./MsgCompleto.vue?vue&type=script&lang=js"
export * from "./MsgCompleto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports